/**
生成模板编译需要的参数工具类
ver 1.0.0
修改记录：
  2018-6-12：
    arrayUtils.
*/
let compileVariableUtil = {}

/**
  生成模板编译需要的参数
 * @param {object} formData 绑定到data属性的数据。
 * @param {vue} vue vue实例

  @return  {object}  内容如下
  {
    currentToken: null,
    routeQuery: null,
    data: formData,
    user: {}
  }

*/
compileVariableUtil.getCompileVariable = function (formData, vue, extendData = null) {
  // console.error("compileVariableUtil.getCompileVariable:formData", formData);
  // from-create 组件中创建组件，获取不到路由和store中的数据，需要兼容性处理。
  var rootVue = null
  if (vue && vue.$route) {
    // console.log("vue.$route", vue.$route);
    rootVue = vue
  }
  if (rootVue == null && window.$vueApp) rootVue = window.$vueApp

  var data = {
    currentToken: null,
    routeQuery: null,
    routerQuery: {},
    data: formData,
    extendData: extendData,
    user: {},
    strategy: {},
    GLOBAL: {},
    organization: {},
    currentTicket: null,
    system: null,
  }
  try {
    data.currentToken = rootVue?.$store?.state.user.currentToken
    data.strategy =
      rootVue?.$store?.state.strategy && rootVue?.$store?.state.strategy.strategy
        ? rootVue?.$store?.state.strategy.strategy
        : {}
    data.routeQuery = rootVue?.$route?.query || {}
    data.currentRouter = rootVue?.$store?.state.menuStore.currentRouter || {}
    // 兼容 部分组件使用routerQuery 导致报错bug。
    data.routerQuery = data.routeQuery
    data.GLOBAL = rootVue?.GLOBAL
    data.organization = rootVue?.$store?.state.user.organization
    data.currentTicket = rootVue?.$store?.state.user.CurrentTicket
    data.system = rootVue?.$store?.state.user.system
  } catch (e) {
    console.error('compileVariableUtil.getCompileVariable', e)
  }

  return data
}

export default compileVariableUtil
